import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

interface Props {
  textInfo: string;
}

const noData = 'Data not available';

const Pending: React.FC<Props> = ({ textInfo }) =>
  textInfo === noData || textInfo === '' ? (
    <FontAwesomeIcon
      className="no-data-icon"
      icon="ban"
      style={{ width: '20px', height: '20px' }}
      title={noData}
    />
  ) : (
    textInfo
  );

export default Pending;
